module.exports = __webpack_public_path__ + "static/media/py.cc9aa61d.svg";